import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-billing-page',
  templateUrl: './admin-billing-page.component.html',
  styleUrls: ['./admin-billing-page.component.scss']
})
export class AdminBillingPageComponent implements OnInit {

  public error = {
    active: false,
    message: "",
    stack: ""
  }

  constructor() { }

  ngOnInit() {
    window['paypal'].Buttons({
      style: {
          shape: 'rect',
          color: 'blue',
          layout: 'vertical',
          label: 'subscribe',

      },
      createSubscription: function(data, actions) {
        return actions.subscription.create({
          'plan_id': 'P-9HE234785C491111FL3VXRUQ'
        });
      },
      onApprove: function(data, actions) {
        alert(data.subscriptionID);
      }
  }).render('.paypal-button-container');
  window['paypal'].Buttons({
    style: {
        shape: 'rect',
        color: 'blue',
        layout: 'vertical',
        label: 'subscribe',

    },
    createSubscription: function(data, actions) {
      return actions.subscription.create({
        'plan_id': 'P-9HE234785C491111FL3VXRUQ'
      });
    },
    onApprove: function(data, actions) {
      alert(data.subscriptionID);
    }
}).render('.paypal-button-container2');
  }

}
